export default "__VITE_PUBLIC_ASSET__64d606db__"